
const getDomainNumber = (url, domainList) => {
  const map = Array.prototype.map;
  const numbers = map.call(url, (x) => x.charCodeAt(0));
  return numbers.reduce((x, y) => x + y) % domainList.length;
};

export default getDomainNumber;
